import React from 'react';
import { Link } from 'react-router-dom';
import PromoEventBadge from './PromoEventBadge';

/**
 * Marqueur promo dashboard organisateur → page de gestion.
 * - Promo active : badge cliquable (+ compteur si plusieurs)
 * - Sinon (optionnel) : lien discret « Créer une promo »
 */
export default function DashboardPromoMarker({
    eventId,
    hasActivePromo = false,
    activeCount = 0,
    showCreateLink = false,
    className = '',
}) {
    if (!eventId) return null;

    const to = `/dashboard/communiquer/promotions/event/${eventId}`;
    const count = Number(activeCount) || 0;

    if (hasActivePromo || count > 0) {
        return (
            <Link
                to={to}
                className={`inline-flex items-center gap-1.5 no-underline hover:opacity-90 ${className}`}
                title="Voir / gérer la promotion tarifaire"
            >
                <PromoEventBadge />
                {count > 1 && (
                    <span className="inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-rose-100 px-1.5 py-0.5 text-[10px] font-bold text-rose-700">
                        {count}
                    </span>
                )}
            </Link>
        );
    }

    if (!showCreateLink) return null;

    return (
        <Link
            to={to}
            className={`text-xs font-medium text-rose-600 hover:text-rose-700 hover:underline ${className}`}
        >
            Créer une promo
        </Link>
    );
}
